import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import { ServiceManager } from '@jutro/services';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from 'gw-digital-auth-react';
import { Avatar, ModalService } from '@jutro/components';
import ClaimFnolInfoTemplate from '../ClaimFnolInfoTemplate/ClaimFnolInfoTemplate';
import { ApplicationHeader, DropdownMenuLink, DropdownMenuAvatar, DropdownMenuSeparator } from '@jutro/router';
import metadata from './PageHeaderComponent.metadata.json5';
import pageHeaderStyles from './PageHeaderComponent.module.scss';
import messages from './PageHeaderComponent.messages';

function PageHeaderComponent(props) {
    const auth = useAuthentication();
    const { getUserProvince } = useAuthentication();
    const { routes, history, logout } = props;
    const translator = useContext(TranslatorContext);
    const { env } = appConfig;
    const breakpoint = useContext(BreakpointTrackerContext);
    const localeService = ServiceManager.getService('locale-service');

    const onFileAClaimButtonClick = useCallback(
        () => {

            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            });
            /* event.preventDefault();
            ModalService.showInfo({
                title: translator(messages.reportClaim),
                message: <ClaimFnolInfoTemplate />
            });*/

        },
        []
    );

    const getMobileAvatar = useCallback(() => {
      //  console.log('--------------------page header--------------------------------------');
        return (<div className="avatarContainer">
                <div>
                    <Avatar
                        id="Avatar"
                        size="large"
                        useAuthInfo={false}
                        username={auth.user_name}
                        title={_.capitalize(auth.name)}
                        subtitle={_.capitalize(auth.user_name)}
                    />
                </div>
                <div className="avatarTitleContainer">
                    <h4>{auth.name}</h4>
                    {auth.user_name}
                </div>
                </div>
            )
    },[auth])


    const getAvatarLinks = useCallback(() => {
        // Need to add the below line to links array, if My Account link to get displayed
        // <DropdownMenuLink to="/userprofile">{translator(messages.account)}</DropdownMenuLink>,

        let links = [
            <DropdownMenuSeparator></DropdownMenuSeparator>,
            getMobileAvatar(),
            <DropdownMenuSeparator></DropdownMenuSeparator>,
            <DropdownMenuLink to="/home">{translator(messages.home)}</DropdownMenuLink>,
            <DropdownMenuLink to="/go-paperless">{translator(messages.goPaperlessHeading)}</DropdownMenuLink>,
            <DropdownMenuLink to="/claims">{translator(messages.myClaims)}</DropdownMenuLink>,
            <DropdownMenuLink to="/billing-summary">{translator(messages.myBillings)}</DropdownMenuLink>,
            <DropdownMenuLink to="/account-documents-summary">{translator(messages.myDocuments)}</DropdownMenuLink>,
            <DropdownMenuLink to="/my-preferences">{translator(messages.myAGM)}</DropdownMenuLink>,
            <DropdownMenuLink href="https://www.heartlandmutualinsurance.com/product/make-a-payment/">{translator(messages.makePayment)}</DropdownMenuLink>,
            <DropdownMenuLink onClick={() => onFileAClaimButtonClick()}>{translator(messages.reportClaim)}</DropdownMenuLink>,
            <DropdownMenuLink to="/faq">{translator(messages.faq)}</DropdownMenuLink>,
        ];

        links = (breakpoint === 'phone') ? links : [];
        // when using jutroAuthContext, jutro application header add the logout link by default
        // avoiding custom logout for gwcp and follow jutro
        if (!auth.useJutroAuthContext) {
            links.push(
                <div>
                    <DropdownMenuLink to="/change-password">{translator(messages.changePassword)}</DropdownMenuLink>
                    <DropdownMenuLink to="/update-email">{translator(messages.updateEmail)}</DropdownMenuLink>
                    <DropdownMenuLink onClick={auth.logout}>{translator(messages.logout)}</DropdownMenuLink>
                </div>
            );
        }
        return links;
    }, [translator, auth]);

    const getLogoSrc = useCallback(() => {
        const url = _.get(env, 'DEPLOYMENT_URL');
        const breakpoint = useContext(BreakpointTrackerContext);
        // const logoUrl = breakpoint === 'desktop' ? `${url}/branding/eylogo.png` : `${url}/branding/eylogo.png`
        const logoUrl = (breakpoint === 'phone') ? `${url}/branding/HFM - Center.JPG` : `${url}/branding/HFM - Center.JPG`
        return logoUrl;
    }, [env]);

    const overrides = {
        applicationheader: {
            avatarProps: {
                username: auth.user_name,
                title: auth.name,
                subtitle: auth.user_name
            },
            avatarChildren: getAvatarLinks(),
            logoSrc: getLogoSrc(),
            navigationRoutes: routes
        },
        gwAuthStatus: {
            username: auth.user_name,
            title: auth.name,
            subtitle: _.capitalize(auth.user_name),
            content: getAvatarLinks()
        },
        navMenuBarContainer: {
            visible: breakpoint == 'phone'
        },
        dropdownMenuButton: {
            content: getAvatarLinks()
        },
        appLogoKings: {
            visible: getUserProvince() === 'NS' && breakpoint !== 'phone'
        }
    };


    const resolvers = {
        resolveClassNameMap: pageHeaderStyles,
        resolveComponentMap: {
            applicationheader: ApplicationHeader
        },
        resolveCallbackMap: {
            onFileAClaimButtonClick: onFileAClaimButtonClick,
            goToLogout: auth.logout
        }
    };



    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

PageHeaderComponent.propTypes = {
    routes: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default withRouter(React.memo(PageHeaderComponent));
